import http from './http';

export default {
  get(data) {
    return http().post(`/v1/leads-table`, data)
  },
  getSourceFilter() {
    return http().get(`v1/leads-table/filter-options`)
  },
  getProcessedMassActions(query) {
    return http().get(`v1/leads-table/processed-actions?` + query)
  },
}
